import { Outlet, createFileRoute } from '@tanstack/react-router';

import VStack from '@/components/Layout/VStack';

import Header from './-layout/Header';

export const Route = createFileRoute('/_staff/software/$id/_$id')({
  component: Layout,
});

function Layout() {
  return (
    <VStack className="h-full">
      <Header />
      <Outlet />
    </VStack>
  );
}
